import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import styles from './Heading.module.css.js';

const tagMap = {
    "1": "h1",
    "2": "h2",
    "3": "h3",
    "4": "h4",
};
function Heading({ level = "3", as, align = "start", multiline = false, children, }) {
    const Tag = as !== null && as !== void 0 ? as : tagMap[level];
    return (jsx(Tag, { className: clsx(styles.Heading, styles[`level${level}`], styles[align], {
            [styles.multiline]: multiline,
        }), children: children }));
}

export { Heading };
//# sourceMappingURL=Heading.js.map
